import { ReactNode, memo } from 'react';
import { Box } from '@amzn/awsui-components-core';

interface PanelSectionProps {
  readonly title: string;
  readonly children: ReactNode;
}

function PanelSection({ title, children }: PanelSectionProps) {
  return (
    <div>
      <Box variant="h4">{title}</Box>
      {children}
    </div>
  );
}

export default memo(PanelSection);
